module.exports = __webpack_public_path__ + "static/media/CSK-horiz-mobile-default@2x.25f8be9b.png";